import { RouteRecordRaw } from "vue-router";
import FlightSearch from "@/modules/Flight/route";
import FlightSearchResult from "@/modules/FlightSearchResult/route";

import BookingRoutes from "@/modules/Booking/route";
import FlightIssuanceRoutes from "@/modules/FlightIssuance/route";

import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";
import FlightRefundRoutes from "@/modules/FlightRefunds/route";

const FlightRoutes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "flights",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS.PERMISSIONS,
    },
    children: [...FlightSearch, ...FlightSearchResult],
  },
  {
    path: "",
    name: "flightBookingForm",
    children: BookingRoutes,
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS_BOOKING_FORM.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS_BOOKING_FORM.PERMISSIONS,
    },
  },
  {
    path: PATH.FLIGHT_ISSUANCE,
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHT_ISSUANCE.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHT_ISSUANCE.PERMISSIONS,
    },
    children: FlightIssuanceRoutes,
  },
  {
    path: PATH.FLIGHT_REFUNDS,
    name: "flightRefunds",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHT_REFUNDS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHT_REFUNDS.PERMISSIONS,
    },
    children: FlightRefundRoutes,
  },
];

export default FlightRoutes;
